<mat-card *ngIf="groups?.length > 0" appearance="outlined" class="custom-measure-component se-block">
    <div class="horizontal-tables-container">
        <table *ngIf="group0" class="measure-table">
            <tr>
                <th scope="col">
                    <mat-icon>print</mat-icon>
                </th>
                <th scope="col">{{ group0.categoryName }}</th>
                <th scope="col">{{ group0.measures && group0.measures.length > 0 ? group0.measures[0].udM : "" }}</th>
            </tr>
            <tr *ngFor="let measure of group0.measures; index as i">
                <td [class.se-read-only]="readOnly">
                    <mat-checkbox
                        (change)="onPrintableChange(group0.measures[i])"
                        [(ngModel)]="measure.isPrintable"
                        type="checkbox"
                    ></mat-checkbox>
                </td>
                <td [matTooltip]="measure.formulaDescription" class="cell-name" matTooltipClass="mat-tooltip-bigger">
                    {{ measure.name }}
                </td>
                <td *ngIf="measure.isCalculated" class="value-udm">
                    <editable-cell
                        [isReadOnly]="readOnly || measure.isCalculated"
                        [ngModel]="group0.measures[i]"
                        path="value"
                    >
                    </editable-cell>
                </td>
                <td *ngIf="!measure.isCalculated" class="value-udm">
                    <editable-cell
                        (valueChange)="onValueChange($event)"
                        [(ngModel)]="group0.measures[i]"
                        [isReadOnly]="readOnly || measure.isCalculated"
                        path="value"
                    ></editable-cell>
                </td>
            </tr>
        </table>

        <div class="vertical-tables-container">
            <table *ngIf="group1" class="measure-table">
                <tr>
                    <th scope="col">
                        <mat-icon>print</mat-icon>
                    </th>
                    <th scope="col">{{ group1.categoryName }}</th>
                    <th scope="col">
                        {{ group1.measures && group1.measures.length > 0 ? group1.measures[0].udM : "" }}
                    </th>
                </tr>
                <tr *ngFor="let measure of group1.measures; index as i">
                    <td [class.se-read-only]="readOnly">
                        <mat-checkbox
                            (change)="onPrintableChange(group1.measures[i])"
                            [(ngModel)]="measure.isPrintable"
                            type="checkbox"
                        ></mat-checkbox>
                    </td>
                    <td
                        [matTooltip]="measure.formulaDescription"
                        class="cell-name"
                        matTooltipClass="mat-tooltip-bigger"
                    >
                        {{ measure.name }}
                    </td>
                    <td *ngIf="measure.isCalculated" class="value-udm">
                        <editable-cell
                            [isReadOnly]="readOnly || measure.isCalculated"
                            [ngModel]="group1.measures[i]"
                            path="value"
                        >
                        </editable-cell>
                    </td>
                    <td *ngIf="!measure.isCalculated" class="value-udm">
                        <editable-cell
                            (valueChange)="onValueChange($event)"
                            [(ngModel)]="group1.measures[i]"
                            [isReadOnly]="readOnly || measure.isCalculated"
                            path="value"
                        ></editable-cell>
                    </td>
                </tr>
            </table>
            <table *ngIf="group2" class="measure-table">
                <tr>
                    <th scope="col">
                        <mat-icon>print</mat-icon>
                    </th>
                    <th scope="col">{{ group2.categoryName }}</th>
                    <th scope="col">
                        {{ group2.measures && group2.measures.length > 0 ? group2.measures[0].udM : "" }}
                    </th>
                </tr>
                <tr *ngFor="let measure of group2.measures; index as i">
                    <td [class.se-read-only]="readOnly">
                        <mat-checkbox [(ngModel)]="measure.isPrintable" type="checkbox"></mat-checkbox>
                    </td>
                    <td
                        [matTooltip]="measure.formulaDescription"
                        class="cell-name"
                        matTooltipClass="mat-tooltip-bigger"
                    >
                        {{ measure.name }}
                    </td>
                    <td *ngIf="measure.isCalculated" class="value-udm">
                        <editable-cell
                            [isReadOnly]="readOnly || measure.isCalculated"
                            [ngModel]="group2.measures[i]"
                            path="value"
                        >
                        </editable-cell>
                    </td>
                    <td *ngIf="!measure.isCalculated" class="value-udm">
                        <editable-cell
                            (valueChange)="onValueChange($event)"
                            [(ngModel)]="group2.measures[i]"
                            [isReadOnly]="readOnly || measure.isCalculated"
                            path="value"
                        ></editable-cell>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</mat-card>
